export default __webpack_public_path__ + "static/media/swingLeft_Logo_color 1.9d1ad3be.svg";